import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { LOGO_URL } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export function Navbar({ onAuth, onSubscribe }) {
  const { user, logout } = useAuth();
  const [scrolled, setScrolled] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      initial={{ y: -80 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
      className={`fixed top-0 inset-x-0 z-[900] transition-colors duration-500 ${
        scrolled
          ? "backdrop-blur-2xl bg-black/60 border-b border-white/10"
          : "bg-transparent"
      }`}
    >
      <div className="flex items-center justify-between px-6 md:px-16 h-20">
        <Link to="/" className="flex items-center gap-3" data-testid="nav-logo">
          <img src={LOGO_URL} alt="It's My Network" className="h-9 w-auto object-contain" />
          <span className="hidden sm:block font-display text-lg font-bold tracking-widest uppercase">
            IMN
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-8 font-mono-imn text-xs tracking-widest uppercase text-white/70">
          <a href="/#originals" className="hover:text-white transition-colors">Originals</a>
          <a href="/#previews" className="hover:text-white transition-colors">Free Previews</a>
          <a href="/#pricing" className="hover:text-white transition-colors">Membership</a>
        </nav>

        <div className="flex items-center gap-3">
          {user && user.role === "admin" && (
            <button
              onClick={() => navigate("/admin")}
              data-testid="nav-admin-btn"
              className="hidden sm:block font-mono-imn text-xs tracking-widest uppercase text-gold hover:opacity-80 transition-opacity"
            >
              Admin
            </button>
          )}
          {user ? (
            <>
              <button
                onClick={() => navigate("/account")}
                data-testid="nav-account-btn"
                className="font-mono-imn text-xs tracking-widest uppercase text-white/70 hover:text-white transition-colors"
              >
                Account
              </button>
              {!user.is_premium && (
                <button
                  onClick={onSubscribe}
                  data-testid="nav-subscribe-btn"
                  className="bg-white text-black text-xs font-semibold uppercase tracking-wider px-4 py-2 hover:bg-white/90 active:scale-95 transition-all"
                >
                  Subscribe
                </button>
              )}
              {user.is_premium && (
                <span className="border border-gold text-gold text-[10px] font-semibold uppercase tracking-widest px-3 py-1.5">
                  Premium
                </span>
              )}
              <button
                onClick={logout}
                data-testid="nav-logout-btn"
                className="font-mono-imn text-xs tracking-widest uppercase text-white/60 hover:text-white transition-colors"
              >
                Logout
              </button>
            </>
          ) : (
            <button
              onClick={onAuth}
              data-testid="nav-signin-btn"
              className="border border-white/20 text-xs font-semibold uppercase tracking-wider px-4 py-2 hover:bg-white/10 transition-colors"
            >
              Sign In
            </button>
          )}
        </div>
      </div>
    </motion.header>
  );
}
